import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import EmbedButton from "source/components/Common/EmbedButton";
import Button from "components/Common/Button";
import { ResponseRecord } from "reducers/responses/reducer";
import { Client } from "resourceModels";
import { getResource } from "selectors/resources";
import {
  openChatInNewWindow,
  getTestBotDomain,
  getTestBotCluster
} from "source/services/test-bot";

export class TestBotOpener extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      client,
      triggerAnswer,
      customClassName,
      buttonProps
    } = this.props;

    const hasEmbeddedTestBot = client.features.get("embedTestBot");

    if (hasEmbeddedTestBot) {
      return (
        <EmbedButton
          handle={client.handle}
          domain={getTestBotDomain()}
          cluster={getTestBotCluster()}
          customClassName={customClassName}
          buttonProps={buttonProps}
          triggerAnswer={triggerAnswer}
        />
      );
    }

    return (
      <Button
        onClick={() => openChatInNewWindow()}
        customClassName={classNames({
          [customClassName]: customClassName
        })}
        text="Test Bot"
        title="Test your bot in a chat window"
        size="small"
        icon="PlaySmall"
        clearWithBorder
      />
    );
  }
}

TestBotOpener.propTypes = {
  client: PropTypes.instanceOf(Client).isRequired,
  triggerAnswer: PropTypes.instanceOf(ResponseRecord),
  customClassName: PropTypes.string,
  buttonProps: PropTypes.objectOf(PropTypes.any)
};

TestBotOpener.defaultProps = {
  triggerAnswer: null,
  customClassName: "",
  buttonProps: {}
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapState(state) {
  return {
    client: getResource(state, "client")
  };
}

const Connector = withRouter(connect(mapState, null)(TestBotOpener));

export default Connector;
